import { emptySplitApi as api } from "./baseApi";
export const addTagTypes = [
	"Article",
	"Cart",
	"Order",
	"Catalogue",
	"Category",
	"Company",
	"Dashboard",
	"Equipment",
	"none",
	"GlAccount",
	"Group",
	"GroupRole",
	"Invoice",
	"Item",
	"Notification",
	"Page",
	"Payment",
	"Report",
	"ScheduleEvent",
	"Search",
	"ServiceOrder",
	"Sites",
	"Template",
	"User",
	"UserNotification",
] as const;
const injectedRtkApi = api
	.enhanceEndpoints({
		addTagTypes,
	})
	.injectEndpoints({
		endpoints: (build) => ({
			getArticle: build.query<GetArticleApiResponse, GetArticleApiArg>({
				query: (queryArg) => ({
					url: `/article`,
					params: {
						ArticleType: queryArg.articleType,
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["Article"],
			}),
			getCartCurrent: build.query<GetCartCurrentApiResponse, GetCartCurrentApiArg>({
				query: () => ({ url: `/cart/current` }),
				providesTags: ["Cart"],
			}),
			getCartCurrentdeliveryinfo: build.query<GetCartCurrentdeliveryinfoApiResponse, GetCartCurrentdeliveryinfoApiArg>({
				query: () => ({ url: `/cart/currentdeliveryinfo` }),
				providesTags: ["Cart"],
			}),
			putCartCurrentItem: build.mutation<PutCartCurrentItemApiResponse, PutCartCurrentItemApiArg>({
				query: (queryArg) => ({ url: `/cart/current/item`, method: "PUT", params: { stockcode: queryArg.stockcode, quantity: queryArg.quantity, siteId: queryArg.siteId, isRechargeable: queryArg.isRechargeable } }),
				invalidatesTags: ["Cart", "Order"],
			}),
			postCart: build.mutation<PostCartApiResponse, PostCartApiArg>({
				query: (queryArg) => ({ url: `/cart`, method: "POST", body: queryArg.cart }),
				invalidatesTags: ["Cart"],
			}),
			putCartById: build.mutation<PutCartByIdApiResponse, PutCartByIdApiArg>({
				query: (queryArg) => ({ url: `/cart/${queryArg.id}`, method: "PUT", body: queryArg.cart }),
				invalidatesTags: ["Cart", "Order"],
			}),
			getCartById: build.query<GetCartByIdApiResponse, GetCartByIdApiArg>({
				query: (queryArg) => ({ url: `/cart/${queryArg.id}` }),
				providesTags: ["Cart"],
			}),
			postCartByIdCheckout: build.mutation<PostCartByIdCheckoutApiResponse, PostCartByIdCheckoutApiArg>({
				query: (queryArg) => ({ url: `/cart/${queryArg.id}/checkout`, method: "POST" }),
				invalidatesTags: ["Cart", "Order"],
			}),
			postCartByIdSetcurrentcart: build.mutation<PostCartByIdSetcurrentcartApiResponse, PostCartByIdSetcurrentcartApiArg>({
				query: (queryArg) => ({ url: `/cart/${queryArg.id}/setcurrentcart`, method: "POST" }),
				invalidatesTags: ["Cart", "Order"],
			}),
			postCartByIdReject: build.mutation<PostCartByIdRejectApiResponse, PostCartByIdRejectApiArg>({
				query: (queryArg) => ({ url: `/cart/${queryArg.id}/reject`, method: "POST" }),
				invalidatesTags: ["Cart", "Order"],
			}),
			postCartByIdClear: build.mutation<PostCartByIdClearApiResponse, PostCartByIdClearApiArg>({
				query: (queryArg) => ({ url: `/cart/${queryArg.id}/clear`, method: "POST" }),
				invalidatesTags: ["Cart", "Order"],
			}),
			postCatalogue: build.mutation<PostCatalogueApiResponse, PostCatalogueApiArg>({
				query: (queryArg) => ({ url: `/catalogue`, method: "POST", body: queryArg.stockCollection }),
				invalidatesTags: ["Catalogue"],
			}),
			getCatalogue: build.query<GetCatalogueApiResponse, GetCatalogueApiArg>({
				query: (queryArg) => ({
					url: `/catalogue`,
					params: {
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["Catalogue"],
			}),
			deleteCatalogueById: build.mutation<DeleteCatalogueByIdApiResponse, DeleteCatalogueByIdApiArg>({
				query: (queryArg) => ({ url: `/catalogue/${queryArg.id}`, method: "DELETE" }),
				invalidatesTags: ["Catalogue"],
			}),
			getCatalogueById: build.query<GetCatalogueByIdApiResponse, GetCatalogueByIdApiArg>({
				query: (queryArg) => ({
					url: `/catalogue/${queryArg.id}`,
					params: {
						SortBy: queryArg.sortBy,
						CategoryIdCollection: queryArg.categoryIdCollection,
						InStock: queryArg.inStock,
						Slug: queryArg.slug,
						StockcodeCollection: queryArg.stockcodeCollection,
						SearchTerm: queryArg.searchTerm,
						IsCore: queryArg.isCore,
						IsApprovedItem: queryArg.isApprovedItem,
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["Catalogue"],
			}),
			putCatalogueById: build.mutation<PutCatalogueByIdApiResponse, PutCatalogueByIdApiArg>({
				query: (queryArg) => ({ url: `/catalogue/${queryArg.id}`, method: "PUT", body: queryArg.stockCollection }),
				invalidatesTags: ["Catalogue"],
			}),
			postCatalogueByIdAdd: build.mutation<PostCatalogueByIdAddApiResponse, PostCatalogueByIdAddApiArg>({
				query: (queryArg) => ({ url: `/catalogue/${queryArg.id}/add`, method: "POST", params: { stockcode: queryArg.stockcode } }),
				invalidatesTags: ["Catalogue"],
			}),
			deleteCatalogueByIdRemove: build.mutation<DeleteCatalogueByIdRemoveApiResponse, DeleteCatalogueByIdRemoveApiArg>({
				query: (queryArg) => ({ url: `/catalogue/${queryArg.id}/remove`, method: "DELETE", params: { stockcode: queryArg.stockcode } }),
				invalidatesTags: ["Catalogue"],
			}),
			putCatalogueByIdUpdate: build.mutation<PutCatalogueByIdUpdateApiResponse, PutCatalogueByIdUpdateApiArg>({
				query: (queryArg) => ({ url: `/catalogue/${queryArg.id}/update`, method: "PUT", params: { stockcode: queryArg.stockcode, isRechargeable: queryArg.isRechargeable } }),
				invalidatesTags: ["Catalogue"],
			}),
			getCategory: build.query<GetCategoryApiResponse, GetCategoryApiArg>({
				query: () => ({ url: `/category` }),
				providesTags: ["Category"],
			}),
			getCategoryBySlug: build.query<GetCategoryBySlugApiResponse, GetCategoryBySlugApiArg>({
				query: (queryArg) => ({ url: `/category/${queryArg.slug}` }),
				providesTags: ["Category"],
			}),
			getCategoryByCategorySlugAndSubCategorySlug: build.query<GetCategoryByCategorySlugAndSubCategorySlugApiResponse, GetCategoryByCategorySlugAndSubCategorySlugApiArg>({
				query: (queryArg) => ({
					url: `/category/${queryArg.categorySlug}/${queryArg.subCategorySlug}`,
					params: {
						SortBy: queryArg.sortBy,
						CategoryIdCollection: queryArg.categoryIdCollection,
						InStock: queryArg.inStock,
						Slug: queryArg.slug,
						StockcodeCollection: queryArg.stockcodeCollection,
						SearchTerm: queryArg.searchTerm,
						IsCore: queryArg.isCore,
						IsApprovedItem: queryArg.isApprovedItem,
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["Category"],
			}),
			getCompany: build.query<GetCompanyApiResponse, GetCompanyApiArg>({
				query: () => ({ url: `/company` }),
				providesTags: ["Company"],
			}),
			getCompanyLocations: build.query<GetCompanyLocationsApiResponse, GetCompanyLocationsApiArg>({
				query: () => ({ url: `/company/locations` }),
				providesTags: ["Company"],
			}),
			getDashboardOrders: build.query<GetDashboardOrdersApiResponse, GetDashboardOrdersApiArg>({
				query: (queryArg) => ({ url: `/dashboard/orders`, params: { StartDate: queryArg.startDate, EndDate: queryArg.endDate, SiteIdCollection: queryArg.siteIdCollection } }),
				providesTags: ["Dashboard"],
			}),
			getDashboardSpend: build.query<GetDashboardSpendApiResponse, GetDashboardSpendApiArg>({
				query: (queryArg) => ({ url: `/dashboard/spend`, params: { StartDate: queryArg.startDate, EndDate: queryArg.endDate, SiteIdCollection: queryArg.siteIdCollection } }),
				providesTags: ["Dashboard"],
			}),
			getDashboardProducts: build.query<GetDashboardProductsApiResponse, GetDashboardProductsApiArg>({
				query: (queryArg) => ({ url: `/dashboard/products`, params: { StartDate: queryArg.startDate, EndDate: queryArg.endDate, SiteIdCollection: queryArg.siteIdCollection } }),
				providesTags: ["Dashboard"],
			}),
			getDashboardEquipments: build.query<GetDashboardEquipmentsApiResponse, GetDashboardEquipmentsApiArg>({
				query: (queryArg) => ({ url: `/dashboard/equipments`, params: { StartDate: queryArg.startDate, EndDate: queryArg.endDate, SiteIdCollection: queryArg.siteIdCollection } }),
				providesTags: ["Dashboard"],
			}),
			getDashboardSites: build.query<GetDashboardSitesApiResponse, GetDashboardSitesApiArg>({
				query: (queryArg) => ({ url: `/dashboard/sites`, params: { StartDate: queryArg.startDate, EndDate: queryArg.endDate, SiteIdCollection: queryArg.siteIdCollection } }),
				providesTags: ["Dashboard"],
			}),
			getDashboardSustainability: build.query<GetDashboardSustainabilityApiResponse, GetDashboardSustainabilityApiArg>({
				query: (queryArg) => ({ url: `/dashboard/sustainability`, params: { StartDate: queryArg.startDate, EndDate: queryArg.endDate, SiteIdCollection: queryArg.siteIdCollection } }),
				providesTags: ["Dashboard"],
			}),
			getEquipment: build.query<GetEquipmentApiResponse, GetEquipmentApiArg>({
				query: (queryArg) => ({
					url: `/equipment`,
					params: {
						SiteIdCollection: queryArg.siteIdCollection,
						EquipmentTypeIdCollection: queryArg.equipmentTypeIdCollection,
						SlugCollection: queryArg.slugCollection,
						GroupIdCollection: queryArg.groupIdCollection,
						IsHire: queryArg.isHire,
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["Equipment"],
			}),
			getEquipmentById: build.query<GetEquipmentByIdApiResponse, GetEquipmentByIdApiArg>({
				query: (queryArg) => ({ url: `/equipment/${queryArg.id}` }),
				providesTags: ["Equipment"],
			}),
			getEquipmentRedirectById: build.query<GetEquipmentRedirectByIdApiResponse, GetEquipmentRedirectByIdApiArg>({
				query: (queryArg) => ({ url: `/equipment/redirect/${queryArg.id}` }),
				providesTags: ["Equipment"],
			}),
			getEquipmentEquipmenttype: build.query<GetEquipmentEquipmenttypeApiResponse, GetEquipmentEquipmenttypeApiArg>({
				query: () => ({ url: `/equipment/equipmenttype` }),
				providesTags: ["Equipment"],
			}),
			postEquipmentByIdLog: build.mutation<PostEquipmentByIdLogApiResponse, PostEquipmentByIdLogApiArg>({
				query: (queryArg) => ({ url: `/equipment/${queryArg.id}/log`, method: "POST", body: queryArg.assetLoggingEvent }),
				invalidatesTags: ["none"],
			}),
			getGlAccount: build.query<GetGlAccountApiResponse, GetGlAccountApiArg>({
				query: (queryArg) => ({
					url: `/gl-account`,
					params: {
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["GlAccount"],
			}),
			postGlAccount: build.mutation<PostGlAccountApiResponse, PostGlAccountApiArg>({
				query: (queryArg) => ({ url: `/gl-account`, method: "POST", body: queryArg.glAccount }),
				invalidatesTags: ["GlAccount"],
			}),
			getGlAccountById: build.query<GetGlAccountByIdApiResponse, GetGlAccountByIdApiArg>({
				query: (queryArg) => ({
					url: `/gl-account/${queryArg.id}`,
					params: {
						SortBy: queryArg.sortBy,
						CategoryIdCollection: queryArg.categoryIdCollection,
						InStock: queryArg.inStock,
						Slug: queryArg.slug,
						StockcodeCollection: queryArg.stockcodeCollection,
						SearchTerm: queryArg.searchTerm,
						IsCore: queryArg.isCore,
						IsApprovedItem: queryArg.isApprovedItem,
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["GlAccount"],
			}),
			putGlAccountById: build.mutation<PutGlAccountByIdApiResponse, PutGlAccountByIdApiArg>({
				query: (queryArg) => ({ url: `/gl-account/${queryArg.id}`, method: "PUT", body: queryArg.glAccount }),
				invalidatesTags: ["GlAccount"],
			}),
			deleteGlAccountById: build.mutation<DeleteGlAccountByIdApiResponse, DeleteGlAccountByIdApiArg>({
				query: (queryArg) => ({ url: `/gl-account/${queryArg.id}`, method: "DELETE" }),
				invalidatesTags: ["GlAccount"],
			}),
			postGlAccountByIdAddstockcode: build.mutation<PostGlAccountByIdAddstockcodeApiResponse, PostGlAccountByIdAddstockcodeApiArg>({
				query: (queryArg) => ({ url: `/gl-account/${queryArg.id}/addstockcode`, method: "POST", params: { stockcode: queryArg.stockcode } }),
				invalidatesTags: ["GlAccount"],
			}),
			deleteGlAccountByIdDeletestockcode: build.mutation<DeleteGlAccountByIdDeletestockcodeApiResponse, DeleteGlAccountByIdDeletestockcodeApiArg>({
				query: (queryArg) => ({ url: `/gl-account/${queryArg.id}/deletestockcode`, method: "DELETE", params: { stockcode: queryArg.stockcode } }),
				invalidatesTags: ["GlAccount"],
			}),
			getGroup: build.query<GetGroupApiResponse, GetGroupApiArg>({
				query: (queryArg) => ({ url: `/group`, params: { SelectedNode: queryArg.selectedNode, IncludePermissions: queryArg.includePermissions, SiteId: queryArg.siteId, SearchForNode: queryArg.searchForNode } }),
				providesTags: ["Group"],
			}),
			postGroup: build.mutation<PostGroupApiResponse, PostGroupApiArg>({
				query: (queryArg) => ({ url: `/group`, method: "POST", body: queryArg.group }),
				invalidatesTags: ["Group"],
			}),
			getGroupById: build.query<GetGroupByIdApiResponse, GetGroupByIdApiArg>({
				query: (queryArg) => ({ url: `/group/${queryArg.id}` }),
				providesTags: ["Group"],
			}),
			putGroupById: build.mutation<PutGroupByIdApiResponse, PutGroupByIdApiArg>({
				query: (queryArg) => ({ url: `/group/${queryArg.id}`, method: "PUT", body: queryArg.group }),
				invalidatesTags: ["Group"],
			}),
			deleteGroupById: build.mutation<DeleteGroupByIdApiResponse, DeleteGroupByIdApiArg>({
				query: (queryArg) => ({ url: `/group/${queryArg.id}`, method: "DELETE" }),
				invalidatesTags: ["Group"],
			}),
			postGroupByIdCreategroup: build.mutation<PostGroupByIdCreategroupApiResponse, PostGroupByIdCreategroupApiArg>({
				query: (queryArg) => ({ url: `/group/${queryArg.id}/creategroup`, method: "POST", body: queryArg.group }),
				invalidatesTags: ["Group"],
			}),
			postGroupByIdCreatesite: build.mutation<PostGroupByIdCreatesiteApiResponse, PostGroupByIdCreatesiteApiArg>({
				query: (queryArg) => ({ url: `/group/${queryArg.id}/createsite`, method: "POST", body: queryArg.site }),
				invalidatesTags: ["Group"],
			}),
			putGroupByIdMove: build.mutation<PutGroupByIdMoveApiResponse, PutGroupByIdMoveApiArg>({
				query: (queryArg) => ({ url: `/group/${queryArg.id}/move`, method: "PUT", params: { newParentId: queryArg.newParentId } }),
				invalidatesTags: ["Group"],
			}),
			getGroupRole: build.query<GetGroupRoleApiResponse, GetGroupRoleApiArg>({
				query: (queryArg) => ({
					url: `/group-role`,
					params: {
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["GroupRole"],
			}),
			postGroupRole: build.mutation<PostGroupRoleApiResponse, PostGroupRoleApiArg>({
				query: (queryArg) => ({ url: `/group-role`, method: "POST", body: queryArg.groupRole }),
				invalidatesTags: ["GroupRole"],
			}),
			getGroupRoleById: build.query<GetGroupRoleByIdApiResponse, GetGroupRoleByIdApiArg>({
				query: (queryArg) => ({ url: `/group-role/${queryArg.id}` }),
				providesTags: ["GroupRole"],
			}),
			putGroupRoleById: build.mutation<PutGroupRoleByIdApiResponse, PutGroupRoleByIdApiArg>({
				query: (queryArg) => ({ url: `/group-role/${queryArg.id}`, method: "PUT", body: queryArg.groupRole }),
				invalidatesTags: ["GroupRole"],
			}),
			deleteGroupRoleById: build.mutation<DeleteGroupRoleByIdApiResponse, DeleteGroupRoleByIdApiArg>({
				query: (queryArg) => ({ url: `/group-role/${queryArg.id}`, method: "DELETE" }),
				invalidatesTags: ["GroupRole"],
			}),
			getInvoice: build.query<GetInvoiceApiResponse, GetInvoiceApiArg>({
				query: (queryArg) => ({
					url: `/invoice`,
					params: {
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["Invoice"],
			}),
			getInvoiceByDocumentNumber: build.query<GetInvoiceByDocumentNumberApiResponse, GetInvoiceByDocumentNumberApiArg>({
				query: (queryArg) => ({ url: `/invoice/${queryArg.documentNumber}` }),
				providesTags: ["Invoice"],
			}),
			getItem: build.query<GetItemApiResponse, GetItemApiArg>({
				query: (queryArg) => ({
					url: `/item`,
					params: {
						SortBy: queryArg.sortBy,
						CategoryIdCollection: queryArg.categoryIdCollection,
						InStock: queryArg.inStock,
						Slug: queryArg.slug,
						StockcodeCollection: queryArg.stockcodeCollection,
						SearchTerm: queryArg.searchTerm,
						IsCore: queryArg.isCore,
						IsApprovedItem: queryArg.isApprovedItem,
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["Item"],
			}),
			postItemFind: build.mutation<PostItemFindApiResponse, PostItemFindApiArg>({
				query: (queryArg) => ({ url: `/item/find`, method: "POST", body: queryArg.itemCriteria }),
				invalidatesTags: ["Item"],
			}),
			getItemBySlug: build.query<GetItemBySlugApiResponse, GetItemBySlugApiArg>({
				query: (queryArg) => ({ url: `/item/${queryArg.slug}` }),
				providesTags: ["Item"],
			}),
			getRecommended: build.query<GetRecommendedApiResponse, GetRecommendedApiArg>({
				query: () => ({ url: `/recommended` }),
				providesTags: ["Item"],
			}),
			getNotification: build.query<GetNotificationApiResponse, GetNotificationApiArg>({
				query: (queryArg) => ({
					url: `/notification`,
					params: {
						SiteIdCollection: queryArg.siteIdCollection,
						EventTypeIdCollection: queryArg.eventTypeIdCollection,
						HasRead: queryArg.hasRead,
						GroupIdCollection: queryArg.groupIdCollection,
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["Notification"],
			}),
			postNotificationMarkread: build.mutation<PostNotificationMarkreadApiResponse, PostNotificationMarkreadApiArg>({
				query: (queryArg) => ({
					url: `/notification/markread`,
					method: "POST",
					params: {
						SiteIdCollection: queryArg.siteIdCollection,
						EventTypeIdCollection: queryArg.eventTypeIdCollection,
						HasRead: queryArg.hasRead,
						GroupIdCollection: queryArg.groupIdCollection,
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				invalidatesTags: ["Notification"],
			}),
			postNotificationMarkunread: build.mutation<PostNotificationMarkunreadApiResponse, PostNotificationMarkunreadApiArg>({
				query: (queryArg) => ({
					url: `/notification/markunread`,
					method: "POST",
					params: {
						SiteIdCollection: queryArg.siteIdCollection,
						EventTypeIdCollection: queryArg.eventTypeIdCollection,
						HasRead: queryArg.hasRead,
						GroupIdCollection: queryArg.groupIdCollection,
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				invalidatesTags: ["Notification"],
			}),
			getOrder: build.query<GetOrderApiResponse, GetOrderApiArg>({
				query: (queryArg) => ({
					url: `/order`,
					params: {
						SortField: queryArg.sortField,
						SortOrder: queryArg.sortOrder,
						SiteIdCollection: queryArg.siteIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						GroupIdCollection: queryArg.groupIdCollection,
						StatusCollection: queryArg.statusCollection,
						SearchTerm: queryArg.searchTerm,
						LastModifiedDateStartDate: queryArg.lastModifiedDateStartDate,
						LastModifiedDateEndDate: queryArg.lastModifiedDateEndDate,
						StartDate: queryArg.startDate,
						EndDate: queryArg.endDate,
						OrderType: queryArg.orderType,
						isAwaitingApproval: queryArg.isAwaitingApproval,
						DocumentNumberCollection: queryArg.documentNumberCollection,
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["Order"],
			}),
			getOrderByDocumentNumber: build.query<GetOrderByDocumentNumberApiResponse, GetOrderByDocumentNumberApiArg>({
				query: (queryArg) => ({ url: `/order/${queryArg.documentNumber}` }),
				providesTags: ["Order"],
			}),
			postOrderByDocumentNumberReorder: build.mutation<PostOrderByDocumentNumberReorderApiResponse, PostOrderByDocumentNumberReorderApiArg>({
				query: (queryArg) => ({ url: `/order/${queryArg.documentNumber}/reorder`, method: "POST" }),
				invalidatesTags: ["Order", "Cart"],
			}),
			getPage: build.query<GetPageApiResponse, GetPageApiArg>({
				query: (queryArg) => ({ url: `/page`, params: { path: queryArg.path } }),
				providesTags: ["Page"],
			}),
			postPageSync: build.mutation<PostPageSyncApiResponse, PostPageSyncApiArg>({
				query: () => ({ url: `/page/sync`, method: "POST" }),
				invalidatesTags: ["Page"],
			}),
			getPageSitemap: build.query<GetPageSitemapApiResponse, GetPageSitemapApiArg>({
				query: (queryArg) => ({ url: `/page/sitemap`, params: { subsidiary: queryArg.subsidiary } }),
				providesTags: ["Page"],
			}),
			getPageProductfeed: build.query<GetPageProductfeedApiResponse, GetPageProductfeedApiArg>({
				query: (queryArg) => ({ url: `/page/productfeed`, params: { subsidiary: queryArg.subsidiary } }),
				providesTags: ["Page"],
			}),
			getPageGeneratemeta: build.query<GetPageGeneratemetaApiResponse, GetPageGeneratemetaApiArg>({
				query: (queryArg) => ({ url: `/page/generatemeta`, params: { path: queryArg.path, isNz: queryArg.isNz } }),
				providesTags: ["Page"],
			}),
			getPayment: build.query<GetPaymentApiResponse, GetPaymentApiArg>({
				query: (queryArg) => ({
					url: `/payment`,
					params: {
						AccountIdCollection: queryArg.accountIdCollection,
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["Payment"],
			}),
			postPayment: build.mutation<PostPaymentApiResponse, PostPaymentApiArg>({
				query: (queryArg) => ({ url: `/payment`, method: "POST", body: queryArg.creditCard }),
				invalidatesTags: ["Payment"],
			}),
			deletePayment: build.mutation<DeletePaymentApiResponse, DeletePaymentApiArg>({
				query: (queryArg) => ({ url: `/payment`, method: "DELETE", body: queryArg.paymentToken }),
				invalidatesTags: ["Payment"],
			}),
			postRechargeableitems: build.mutation<PostRechargeableitemsApiResponse, PostRechargeableitemsApiArg>({
				query: (queryArg) => ({
					url: `/rechargeableitems`,
					method: "POST",
					params: {
						StartDate: queryArg.startDate,
						EndDate: queryArg.endDate,
						AccountIdCollection: queryArg.accountIdCollection,
						SiteIdCollection: queryArg.siteIdCollection,
						GroupIdCollection: queryArg.groupIdCollection,
						IsScheduledReport: queryArg.isScheduledReport,
						DownloadNow: queryArg.downloadNow,
					},
				}),
				invalidatesTags: ["Report"],
			}),
			postBackorders: build.mutation<PostBackordersApiResponse, PostBackordersApiArg>({
				query: (queryArg) => ({
					url: `/backorders`,
					method: "POST",
					params: {
						StartDate: queryArg.startDate,
						EndDate: queryArg.endDate,
						AccountIdCollection: queryArg.accountIdCollection,
						SiteIdCollection: queryArg.siteIdCollection,
						GroupIdCollection: queryArg.groupIdCollection,
						IsScheduledReport: queryArg.isScheduledReport,
						DownloadNow: queryArg.downloadNow,
					},
				}),
				invalidatesTags: ["Report"],
			}),
			postStockusagebysite: build.mutation<PostStockusagebysiteApiResponse, PostStockusagebysiteApiArg>({
				query: (queryArg) => ({
					url: `/stockusagebysite`,
					method: "POST",
					params: {
						StartDate: queryArg.startDate,
						EndDate: queryArg.endDate,
						AccountIdCollection: queryArg.accountIdCollection,
						SiteIdCollection: queryArg.siteIdCollection,
						GroupIdCollection: queryArg.groupIdCollection,
						IsScheduledReport: queryArg.isScheduledReport,
						DownloadNow: queryArg.downloadNow,
					},
				}),
				invalidatesTags: ["Report"],
			}),
			postStockusagebysitebymonth: build.mutation<PostStockusagebysitebymonthApiResponse, PostStockusagebysitebymonthApiArg>({
				query: (queryArg) => ({
					url: `/stockusagebysitebymonth`,
					method: "POST",
					params: {
						StartDate: queryArg.startDate,
						EndDate: queryArg.endDate,
						AccountIdCollection: queryArg.accountIdCollection,
						SiteIdCollection: queryArg.siteIdCollection,
						GroupIdCollection: queryArg.groupIdCollection,
						IsScheduledReport: queryArg.isScheduledReport,
						DownloadNow: queryArg.downloadNow,
					},
				}),
				invalidatesTags: ["Report"],
			}),
			postPurchases: build.mutation<PostPurchasesApiResponse, PostPurchasesApiArg>({
				query: (queryArg) => ({
					url: `/purchases`,
					method: "POST",
					params: {
						StartDate: queryArg.startDate,
						EndDate: queryArg.endDate,
						AccountIdCollection: queryArg.accountIdCollection,
						SiteIdCollection: queryArg.siteIdCollection,
						GroupIdCollection: queryArg.groupIdCollection,
						IsScheduledReport: queryArg.isScheduledReport,
						DownloadNow: queryArg.downloadNow,
					},
				}),
				invalidatesTags: ["Report"],
			}),
			postOperations: build.mutation<PostOperationsApiResponse, PostOperationsApiArg>({
				query: (queryArg) => ({
					url: `/operations`,
					method: "POST",
					params: {
						StartDate: queryArg.startDate,
						EndDate: queryArg.endDate,
						AccountIdCollection: queryArg.accountIdCollection,
						SiteIdCollection: queryArg.siteIdCollection,
						GroupIdCollection: queryArg.groupIdCollection,
						IsScheduledReport: queryArg.isScheduledReport,
						DownloadNow: queryArg.downloadNow,
					},
				}),
				invalidatesTags: ["Report"],
			}),
			postDifot: build.mutation<PostDifotApiResponse, PostDifotApiArg>({
				query: (queryArg) => ({
					url: `/difot`,
					method: "POST",
					params: {
						StartDate: queryArg.startDate,
						EndDate: queryArg.endDate,
						AccountIdCollection: queryArg.accountIdCollection,
						SiteIdCollection: queryArg.siteIdCollection,
						GroupIdCollection: queryArg.groupIdCollection,
						IsScheduledReport: queryArg.isScheduledReport,
						DownloadNow: queryArg.downloadNow,
					},
				}),
				invalidatesTags: ["Report"],
			}),
			getScheduleEvent: build.query<GetScheduleEventApiResponse, GetScheduleEventApiArg>({
				query: (queryArg) => ({
					url: `/schedule-event`,
					params: {
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["ScheduleEvent"],
			}),
			postScheduleEvent: build.mutation<PostScheduleEventApiResponse, PostScheduleEventApiArg>({
				query: (queryArg) => ({ url: `/schedule-event`, method: "POST", body: queryArg.scheduleReport }),
				invalidatesTags: ["ScheduleEvent"],
			}),
			getScheduleEventById: build.query<GetScheduleEventByIdApiResponse, GetScheduleEventByIdApiArg>({
				query: (queryArg) => ({ url: `/schedule-event/${queryArg.id}` }),
				providesTags: ["ScheduleEvent"],
			}),
			putScheduleEventById: build.mutation<PutScheduleEventByIdApiResponse, PutScheduleEventByIdApiArg>({
				query: (queryArg) => ({ url: `/schedule-event/${queryArg.id}`, method: "PUT", body: queryArg.scheduleReport }),
				invalidatesTags: ["ScheduleEvent"],
			}),
			deleteScheduleEventById: build.mutation<DeleteScheduleEventByIdApiResponse, DeleteScheduleEventByIdApiArg>({
				query: (queryArg) => ({ url: `/schedule-event/${queryArg.id}`, method: "DELETE" }),
				invalidatesTags: ["ScheduleEvent"],
			}),
			getSearch: build.query<GetSearchApiResponse, GetSearchApiArg>({
				query: (queryArg) => ({
					url: `/search`,
					params: {
						searchTerm: queryArg.searchTerm,
						SortBy: queryArg.sortBy,
						CategoryIdCollection: queryArg.categoryIdCollection,
						InStock: queryArg.inStock,
						Slug: queryArg.slug,
						StockcodeCollection: queryArg.stockcodeCollection,
						SearchTerm: queryArg.SearchTerm,
						IsCore: queryArg.isCore,
						IsApprovedItem: queryArg.isApprovedItem,
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["Search"],
			}),
			getServiceOrder: build.query<GetServiceOrderApiResponse, GetServiceOrderApiArg>({
				query: (queryArg) => ({
					url: `/service-order`,
					params: {
						EquipmentIdCollection: queryArg.equipmentIdCollection,
						StartDate: queryArg.startDate,
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["ServiceOrder"],
			}),
			postServiceOrder: build.mutation<PostServiceOrderApiResponse, PostServiceOrderApiArg>({
				query: (queryArg) => ({ url: `/service-order`, method: "POST", body: queryArg.createServiceOrderRequest }),
				invalidatesTags: ["ServiceOrder"],
			}),
			getServiceOrderById: build.query<GetServiceOrderByIdApiResponse, GetServiceOrderByIdApiArg>({
				query: (queryArg) => ({ url: `/service-order/${queryArg.id}` }),
				providesTags: ["ServiceOrder"],
			}),
			putServiceOrderById: build.mutation<PutServiceOrderByIdApiResponse, PutServiceOrderByIdApiArg>({
				query: (queryArg) => ({ url: `/service-order/${queryArg.id}`, method: "PUT", body: queryArg.createServiceOrderRequest }),
				invalidatesTags: ["ServiceOrder"],
			}),
			getSitesByIdSafety: build.query<GetSitesByIdSafetyApiResponse, GetSitesByIdSafetyApiArg>({
				query: (queryArg) => ({ url: `/sites/${queryArg.id}/safety` }),
				providesTags: ["Sites"],
			}),
			getSitesDownload: build.query<GetSitesDownloadApiResponse, GetSitesDownloadApiArg>({
				query: (queryArg) => ({ url: `/sites/download`, body: queryArg.siteCriteria }),
				providesTags: ["Sites"],
			}),
			patchSitesUpload: build.mutation<PatchSitesUploadApiResponse, PatchSitesUploadApiArg>({
				query: (queryArg) => ({ url: `/sites/upload`, method: "PATCH", body: queryArg.body }),
				invalidatesTags: ["Sites"],
			}),
			postSites: build.mutation<PostSitesApiResponse, PostSitesApiArg>({
				query: (queryArg) => ({ url: `/sites`, method: "POST", body: queryArg.site }),
				invalidatesTags: ["Sites"],
			}),
			getSites: build.query<GetSitesApiResponse, GetSitesApiArg>({
				query: (queryArg) => ({
					url: `/sites`,
					params: {
						SearchTerm: queryArg.searchTerm,
						SortField: queryArg.sortField,
						SortDirection: queryArg.sortDirection,
						GroupIdCollection: queryArg.groupIdCollection,
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["Sites"],
			}),
			putSitesById: build.mutation<PutSitesByIdApiResponse, PutSitesByIdApiArg>({
				query: (queryArg) => ({ url: `/sites/${queryArg.id}`, method: "PUT", body: queryArg.site }),
				invalidatesTags: ["Sites"],
			}),
			getSitesById: build.query<GetSitesByIdApiResponse, GetSitesByIdApiArg>({
				query: (queryArg) => ({ url: `/sites/${queryArg.id}` }),
				providesTags: ["Sites"],
			}),
			getTemplate: build.query<GetTemplateApiResponse, GetTemplateApiArg>({
				query: (queryArg) => ({
					url: `/template`,
					params: {
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["Template"],
			}),
			postTemplate: build.mutation<PostTemplateApiResponse, PostTemplateApiArg>({
				query: (queryArg) => ({ url: `/template`, method: "POST", body: queryArg.stockCollection }),
				invalidatesTags: ["Template"],
			}),
			deleteTemplateById: build.mutation<DeleteTemplateByIdApiResponse, DeleteTemplateByIdApiArg>({
				query: (queryArg) => ({ url: `/template/${queryArg.id}`, method: "DELETE" }),
				invalidatesTags: ["Template"],
			}),
			getTemplateById: build.query<GetTemplateByIdApiResponse, GetTemplateByIdApiArg>({
				query: (queryArg) => ({
					url: `/template/${queryArg.id}`,
					params: {
						SortBy: queryArg.sortBy,
						CategoryIdCollection: queryArg.categoryIdCollection,
						InStock: queryArg.inStock,
						Slug: queryArg.slug,
						StockcodeCollection: queryArg.stockcodeCollection,
						SearchTerm: queryArg.searchTerm,
						IsCore: queryArg.isCore,
						IsApprovedItem: queryArg.isApprovedItem,
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["Template"],
			}),
			putTemplateById: build.mutation<PutTemplateByIdApiResponse, PutTemplateByIdApiArg>({
				query: (queryArg) => ({ url: `/template/${queryArg.id}`, method: "PUT", body: queryArg.stockCollection }),
				invalidatesTags: ["Template"],
			}),
			postTemplateByIdAdd: build.mutation<PostTemplateByIdAddApiResponse, PostTemplateByIdAddApiArg>({
				query: (queryArg) => ({ url: `/template/${queryArg.id}/add`, method: "POST", params: { stockcode: queryArg.stockcode } }),
				invalidatesTags: ["Template"],
			}),
			deleteTemplateByIdRemove: build.mutation<DeleteTemplateByIdRemoveApiResponse, DeleteTemplateByIdRemoveApiArg>({
				query: (queryArg) => ({ url: `/template/${queryArg.id}/remove`, method: "DELETE", params: { stockcode: queryArg.stockcode } }),
				invalidatesTags: ["Template"],
			}),
			getUser: build.query<GetUserApiResponse, GetUserApiArg>({
				query: (queryArg) => ({
					url: `/user`,
					params: {
						Email: queryArg.email,
						HasPassword: queryArg.hasPassword,
						PageNumber: queryArg.pageNumber,
						PageSize: queryArg.pageSize,
						CompanyIdCollection: queryArg.companyIdCollection,
						UserIdCollection: queryArg.userIdCollection,
						IdCollection: queryArg.idCollection,
						IncludeDeleted: queryArg.includeDeleted,
						ReferenceCollection: queryArg.referenceCollection,
					},
				}),
				providesTags: ["User"],
			}),
			postUser: build.mutation<PostUserApiResponse, PostUserApiArg>({
				query: (queryArg) => ({ url: `/user`, method: "POST", body: queryArg.user }),
				invalidatesTags: ["User"],
			}),
			getUserById: build.query<GetUserByIdApiResponse, GetUserByIdApiArg>({
				query: (queryArg) => ({ url: `/user/${queryArg.id}` }),
				providesTags: ["User"],
			}),
			putUserById: build.mutation<PutUserByIdApiResponse, PutUserByIdApiArg>({
				query: (queryArg) => ({ url: `/user/${queryArg.id}`, method: "PUT", body: queryArg.user }),
				invalidatesTags: ["User"],
			}),
			deleteUserById: build.mutation<DeleteUserByIdApiResponse, DeleteUserByIdApiArg>({
				query: (queryArg) => ({ url: `/user/${queryArg.id}`, method: "DELETE" }),
				invalidatesTags: ["User"],
			}),
			postUserRegister: build.mutation<PostUserRegisterApiResponse, PostUserRegisterApiArg>({
				query: (queryArg) => ({ url: `/user/register`, method: "POST", body: queryArg.clerkUserCreate }),
				invalidatesTags: ["User"],
			}),
			postUserSetup: build.mutation<PostUserSetupApiResponse, PostUserSetupApiArg>({
				query: (queryArg) => ({ url: `/user/setup`, method: "POST", body: queryArg.userSetup }),
				invalidatesTags: ["User"],
			}),
			postUserChangePassword: build.mutation<PostUserChangePasswordApiResponse, PostUserChangePasswordApiArg>({
				query: (queryArg) => ({ url: `/user/change-password`, method: "POST", body: queryArg.userChangePassword }),
				invalidatesTags: ["User"],
			}),
			getUserCurrent: build.query<GetUserCurrentApiResponse, GetUserCurrentApiArg>({
				query: () => ({ url: `/user/current` }),
				providesTags: ["User"],
			}),
			getUserNotificationById: build.query<GetUserNotificationByIdApiResponse, GetUserNotificationByIdApiArg>({
				query: (queryArg) => ({ url: `/user-notification/${queryArg.id}` }),
				providesTags: ["UserNotification"],
			}),
			putUserNotificationById: build.mutation<PutUserNotificationByIdApiResponse, PutUserNotificationByIdApiArg>({
				query: (queryArg) => ({ url: `/user-notification/${queryArg.id}`, method: "PUT", body: queryArg.userNotification }),
				invalidatesTags: ["UserNotification"],
			}),
		}),
		overrideExisting: false,
	});
export { injectedRtkApi as abcoApi };
export type GetArticleApiResponse = /** status 200 OK */ PageSerializableListResultRead;
export type GetArticleApiArg = {
	articleType?: number;
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type GetCartCurrentApiResponse = /** status 200 OK */ CartRead;
export type GetCartCurrentApiArg = void;
export type GetCartCurrentdeliveryinfoApiResponse = /** status 200 OK */ CartDeliveryInfo;
export type GetCartCurrentdeliveryinfoApiArg = void;
export type PutCartCurrentItemApiResponse = unknown;
export type PutCartCurrentItemApiArg = {
	stockcode?: string;
	quantity?: number;
	siteId?: number;
	isRechargeable?: boolean;
};
export type PostCartApiResponse = /** status 200 OK */ CartRead;
export type PostCartApiArg = {
	cart: Cart;
};
export type PutCartByIdApiResponse = /** status 200 OK */ CartRead;
export type PutCartByIdApiArg = {
	id: number;
	cart: Cart;
};
export type GetCartByIdApiResponse = /** status 200 OK */ CartRead;
export type GetCartByIdApiArg = {
	id: number;
};
export type PostCartByIdCheckoutApiResponse = /** status 200 OK */ CartCheckoutResponseRead;
export type PostCartByIdCheckoutApiArg = {
	id: number;
};
export type PostCartByIdSetcurrentcartApiResponse = /** status 200 OK */ CartRead;
export type PostCartByIdSetcurrentcartApiArg = {
	id: number;
};
export type PostCartByIdRejectApiResponse = /** status 200 OK */ CartCheckoutResponseRead;
export type PostCartByIdRejectApiArg = {
	id: number;
};
export type PostCartByIdClearApiResponse = /** status 200 OK */ CartRead;
export type PostCartByIdClearApiArg = {
	id: number;
};
export type PostCatalogueApiResponse = /** status 200 OK */ StockCollectionRead;
export type PostCatalogueApiArg = {
	stockCollection: StockCollection;
};
export type GetCatalogueApiResponse = /** status 200 OK */ StockCollectionSerializableListResultRead;
export type GetCatalogueApiArg = {
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type DeleteCatalogueByIdApiResponse = unknown;
export type DeleteCatalogueByIdApiArg = {
	id: number;
};
export type GetCatalogueByIdApiResponse = /** status 200 OK */ StockCollectionRead;
export type GetCatalogueByIdApiArg = {
	id: number;
	sortBy?: string;
	categoryIdCollection?: number[];
	inStock?: boolean;
	slug?: string;
	stockcodeCollection?: string[];
	searchTerm?: string;
	isCore?: boolean;
	isApprovedItem?: boolean;
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type PutCatalogueByIdApiResponse = /** status 200 OK */ StockCollectionRead;
export type PutCatalogueByIdApiArg = {
	id: number;
	stockCollection: StockCollection;
};
export type PostCatalogueByIdAddApiResponse = unknown;
export type PostCatalogueByIdAddApiArg = {
	id: number;
	stockcode?: string;
};
export type DeleteCatalogueByIdRemoveApiResponse = unknown;
export type DeleteCatalogueByIdRemoveApiArg = {
	id: number;
	stockcode?: string;
};
export type PutCatalogueByIdUpdateApiResponse = unknown;
export type PutCatalogueByIdUpdateApiArg = {
	id: number;
	stockcode?: string;
	isRechargeable?: boolean;
};
export type GetCategoryApiResponse = /** status 200 OK */ ItemCategoryRead[];
export type GetCategoryApiArg = void;
export type GetCategoryBySlugApiResponse = /** status 200 OK */ ItemCategoryRead;
export type GetCategoryBySlugApiArg = {
	slug: string;
};
export type GetCategoryByCategorySlugAndSubCategorySlugApiResponse = /** status 200 OK */ ItemSubCategoryRead;
export type GetCategoryByCategorySlugAndSubCategorySlugApiArg = {
	categorySlug: string;
	subCategorySlug: string;
	sortBy?: string;
	categoryIdCollection?: number[];
	inStock?: boolean;
	slug?: string;
	stockcodeCollection?: string[];
	searchTerm?: string;
	isCore?: boolean;
	isApprovedItem?: boolean;
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type GetCompanyApiResponse = /** status 200 OK */ Company;
export type GetCompanyApiArg = void;
export type GetCompanyLocationsApiResponse = /** status 200 OK */ Location[];
export type GetCompanyLocationsApiArg = void;
export type GetDashboardOrdersApiResponse = /** status 200 OK */ OrdersDashboard;
export type GetDashboardOrdersApiArg = {
	startDate?: string;
	endDate?: string;
	siteIdCollection?: number[];
};
export type GetDashboardSpendApiResponse = /** status 200 OK */ SpendDashboard;
export type GetDashboardSpendApiArg = {
	startDate?: string;
	endDate?: string;
	siteIdCollection?: number[];
};
export type GetDashboardProductsApiResponse = /** status 200 OK */ ProductsDashboardRead;
export type GetDashboardProductsApiArg = {
	startDate?: string;
	endDate?: string;
	siteIdCollection?: number[];
};
export type GetDashboardEquipmentsApiResponse = /** status 200 OK */ EquipmentDashboard;
export type GetDashboardEquipmentsApiArg = {
	startDate?: string;
	endDate?: string;
	siteIdCollection?: number[];
};
export type GetDashboardSitesApiResponse = /** status 200 OK */ SitesDashboard;
export type GetDashboardSitesApiArg = {
	startDate?: string;
	endDate?: string;
	siteIdCollection?: number[];
};
export type GetDashboardSustainabilityApiResponse = /** status 200 OK */ SustainabilityDashboardRead;
export type GetDashboardSustainabilityApiArg = {
	startDate?: string;
	endDate?: string;
	siteIdCollection?: number[];
};
export type GetEquipmentApiResponse = /** status 200 OK */ EquipmentSerializableListResultRead;
export type GetEquipmentApiArg = {
	siteIdCollection?: number[];
	equipmentTypeIdCollection?: number[];
	slugCollection?: string[];
	groupIdCollection?: number[];
	isHire?: boolean;
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type GetEquipmentByIdApiResponse = /** status 200 OK */ EquipmentRead;
export type GetEquipmentByIdApiArg = {
	id: string;
};
export type GetEquipmentRedirectByIdApiResponse = unknown;
export type GetEquipmentRedirectByIdApiArg = {
	id: string;
};
export type GetEquipmentEquipmenttypeApiResponse = /** status 200 OK */ EquipmentType[];
export type GetEquipmentEquipmenttypeApiArg = void;
export type PostEquipmentByIdLogApiResponse = unknown;
export type PostEquipmentByIdLogApiArg = {
	id: number;
	assetLoggingEvent: AssetLoggingEvent;
};
export type GetGlAccountApiResponse = /** status 200 OK */ GlAccountSerializableListResultRead;
export type GetGlAccountApiArg = {
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type PostGlAccountApiResponse = /** status 200 OK */ GlAccountRead;
export type PostGlAccountApiArg = {
	glAccount: GlAccount;
};
export type GetGlAccountByIdApiResponse = /** status 200 OK */ GlAccountRead;
export type GetGlAccountByIdApiArg = {
	id: number;
	sortBy?: string;
	categoryIdCollection?: number[];
	inStock?: boolean;
	slug?: string;
	stockcodeCollection?: string[];
	searchTerm?: string;
	isCore?: boolean;
	isApprovedItem?: boolean;
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type PutGlAccountByIdApiResponse = /** status 200 OK */ GlAccountRead;
export type PutGlAccountByIdApiArg = {
	id: number;
	glAccount: GlAccount;
};
export type DeleteGlAccountByIdApiResponse = unknown;
export type DeleteGlAccountByIdApiArg = {
	id: number;
};
export type PostGlAccountByIdAddstockcodeApiResponse = unknown;
export type PostGlAccountByIdAddstockcodeApiArg = {
	id: number;
	stockcode?: string;
};
export type DeleteGlAccountByIdDeletestockcodeApiResponse = unknown;
export type DeleteGlAccountByIdDeletestockcodeApiArg = {
	id: number;
	stockcode?: string;
};
export type GetGroupApiResponse = /** status 200 OK */ TreeNode;
export type GetGroupApiArg = {
	selectedNode?: number;
	includePermissions?: boolean;
	siteId?: number;
	searchForNode?: number;
};
export type PostGroupApiResponse = /** status 200 OK */ GroupRead;
export type PostGroupApiArg = {
	group: Group;
};
export type GetGroupByIdApiResponse = /** status 200 OK */ GroupRead;
export type GetGroupByIdApiArg = {
	id: number;
};
export type PutGroupByIdApiResponse = /** status 200 OK */ GroupRead;
export type PutGroupByIdApiArg = {
	id: number;
	group: Group;
};
export type DeleteGroupByIdApiResponse = unknown;
export type DeleteGroupByIdApiArg = {
	id: number;
};
export type PostGroupByIdCreategroupApiResponse = /** status 200 OK */ number;
export type PostGroupByIdCreategroupApiArg = {
	id: number;
	group: Group;
};
export type PostGroupByIdCreatesiteApiResponse = /** status 200 OK */ number;
export type PostGroupByIdCreatesiteApiArg = {
	id: number;
	site: Site;
};
export type PutGroupByIdMoveApiResponse = unknown;
export type PutGroupByIdMoveApiArg = {
	id: number;
	newParentId?: number;
};
export type GetGroupRoleApiResponse = /** status 200 OK */ GroupRoleSerializableListResult;
export type GetGroupRoleApiArg = {
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type PostGroupRoleApiResponse = /** status 200 OK */ GroupRole;
export type PostGroupRoleApiArg = {
	groupRole: GroupRole;
};
export type GetGroupRoleByIdApiResponse = /** status 200 OK */ GroupRole;
export type GetGroupRoleByIdApiArg = {
	id: number;
};
export type PutGroupRoleByIdApiResponse = /** status 200 OK */ GroupRole;
export type PutGroupRoleByIdApiArg = {
	id: number;
	groupRole: GroupRole;
};
export type DeleteGroupRoleByIdApiResponse = unknown;
export type DeleteGroupRoleByIdApiArg = {
	id: number;
};
export type GetInvoiceApiResponse = /** status 200 OK */ InvoiceSerializableListResultRead;
export type GetInvoiceApiArg = {
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type GetInvoiceByDocumentNumberApiResponse = /** status 200 OK */ InvoiceRead;
export type GetInvoiceByDocumentNumberApiArg = {
	documentNumber: string;
};
export type GetItemApiResponse = /** status 200 OK */ ItemSerializableListResultRead;
export type GetItemApiArg = {
	sortBy?: string;
	categoryIdCollection?: number[];
	inStock?: boolean;
	slug?: string;
	stockcodeCollection?: string[];
	searchTerm?: string;
	isCore?: boolean;
	isApprovedItem?: boolean;
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type PostItemFindApiResponse = /** status 200 OK */ ItemSerializableListResultRead;
export type PostItemFindApiArg = {
	itemCriteria: ItemCriteria;
};
export type GetItemBySlugApiResponse = /** status 200 OK */ ItemRead;
export type GetItemBySlugApiArg = {
	slug: string;
};
export type GetRecommendedApiResponse = /** status 200 OK */ ItemRead[];
export type GetRecommendedApiArg = void;
export type GetNotificationApiResponse = /** status 200 OK */ NotificationSerializableListResultRead;
export type GetNotificationApiArg = {
	siteIdCollection?: number[];
	eventTypeIdCollection?: number[];
	hasRead?: boolean;
	groupIdCollection?: number[];
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type PostNotificationMarkreadApiResponse = unknown;
export type PostNotificationMarkreadApiArg = {
	siteIdCollection?: number[];
	eventTypeIdCollection?: number[];
	hasRead?: boolean;
	groupIdCollection?: number[];
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type PostNotificationMarkunreadApiResponse = unknown;
export type PostNotificationMarkunreadApiArg = {
	siteIdCollection?: number[];
	eventTypeIdCollection?: number[];
	hasRead?: boolean;
	groupIdCollection?: number[];
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type GetOrderApiResponse = /** status 200 OK */ OrderCartSerializableListResultRead;
export type GetOrderApiArg = {
	sortField?: string;
	sortOrder?: string;
	siteIdCollection?: number[];
	userIdCollection?: number[];
	groupIdCollection?: number[];
	statusCollection?: string[];
	searchTerm?: string;
	lastModifiedDateStartDate?: string;
	lastModifiedDateEndDate?: string;
	startDate?: string;
	endDate?: string;
	orderType?: string;
	isAwaitingApproval?: boolean;
	documentNumberCollection?: string[];
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type GetOrderByDocumentNumberApiResponse = /** status 200 OK */ OrderRead;
export type GetOrderByDocumentNumberApiArg = {
	documentNumber: string;
};
export type PostOrderByDocumentNumberReorderApiResponse = unknown;
export type PostOrderByDocumentNumberReorderApiArg = {
	documentNumber: string;
};
export type GetPageApiResponse = /** status 200 OK */ PageRead;
export type GetPageApiArg = {
	path?: string;
};
export type PostPageSyncApiResponse = unknown;
export type PostPageSyncApiArg = void;
export type GetPageSitemapApiResponse = unknown;
export type GetPageSitemapApiArg = {
	subsidiary?: number;
};
export type GetPageProductfeedApiResponse = unknown;
export type GetPageProductfeedApiArg = {
	subsidiary?: number;
};
export type GetPageGeneratemetaApiResponse = /** status 200 OK */ string;
export type GetPageGeneratemetaApiArg = {
	path?: string;
	isNz?: boolean;
};
export type GetPaymentApiResponse = /** status 200 OK */ PaymentToken[];
export type GetPaymentApiArg = {
	accountIdCollection?: number[];
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type PostPaymentApiResponse = /** status 200 OK */ PaymentToken;
export type PostPaymentApiArg = {
	creditCard: CreditCard;
};
export type DeletePaymentApiResponse = unknown;
export type DeletePaymentApiArg = {
	paymentToken: PaymentToken;
};
export type PostRechargeableitemsApiResponse = unknown;
export type PostRechargeableitemsApiArg = {
	startDate?: string;
	endDate?: string;
	accountIdCollection?: number[];
	siteIdCollection?: number[];
	groupIdCollection?: number[];
	isScheduledReport?: boolean;
	downloadNow?: boolean;
};
export type PostBackordersApiResponse = unknown;
export type PostBackordersApiArg = {
	startDate?: string;
	endDate?: string;
	accountIdCollection?: number[];
	siteIdCollection?: number[];
	groupIdCollection?: number[];
	isScheduledReport?: boolean;
	downloadNow?: boolean;
};
export type PostStockusagebysiteApiResponse = unknown;
export type PostStockusagebysiteApiArg = {
	startDate?: string;
	endDate?: string;
	accountIdCollection?: number[];
	siteIdCollection?: number[];
	groupIdCollection?: number[];
	isScheduledReport?: boolean;
	downloadNow?: boolean;
};
export type PostStockusagebysitebymonthApiResponse = unknown;
export type PostStockusagebysitebymonthApiArg = {
	startDate?: string;
	endDate?: string;
	accountIdCollection?: number[];
	siteIdCollection?: number[];
	groupIdCollection?: number[];
	isScheduledReport?: boolean;
	downloadNow?: boolean;
};
export type PostPurchasesApiResponse = unknown;
export type PostPurchasesApiArg = {
	startDate?: string;
	endDate?: string;
	accountIdCollection?: number[];
	siteIdCollection?: number[];
	groupIdCollection?: number[];
	isScheduledReport?: boolean;
	downloadNow?: boolean;
};
export type PostOperationsApiResponse = unknown;
export type PostOperationsApiArg = {
	startDate?: string;
	endDate?: string;
	accountIdCollection?: number[];
	siteIdCollection?: number[];
	groupIdCollection?: number[];
	isScheduledReport?: boolean;
	downloadNow?: boolean;
};
export type PostDifotApiResponse = unknown;
export type PostDifotApiArg = {
	startDate?: string;
	endDate?: string;
	accountIdCollection?: number[];
	siteIdCollection?: number[];
	groupIdCollection?: number[];
	isScheduledReport?: boolean;
	downloadNow?: boolean;
};
export type GetScheduleEventApiResponse = /** status 200 OK */ ScheduleReportSerializableListResult;
export type GetScheduleEventApiArg = {
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type PostScheduleEventApiResponse = /** status 200 OK */ ScheduleReport;
export type PostScheduleEventApiArg = {
	scheduleReport: ScheduleReport;
};
export type GetScheduleEventByIdApiResponse = /** status 200 OK */ ScheduleReport;
export type GetScheduleEventByIdApiArg = {
	id: number;
};
export type PutScheduleEventByIdApiResponse = /** status 200 OK */ ScheduleReport;
export type PutScheduleEventByIdApiArg = {
	id: number;
	scheduleReport: ScheduleReport;
};
export type DeleteScheduleEventByIdApiResponse = unknown;
export type DeleteScheduleEventByIdApiArg = {
	id: number;
};
export type GetSearchApiResponse = /** status 200 OK */ SearchResultRead;
export type GetSearchApiArg = {
	searchTerm?: string;
	sortBy?: string;
	categoryIdCollection?: number[];
	inStock?: boolean;
	slug?: string;
	stockcodeCollection?: string[];
	SearchTerm?: string;
	isCore?: boolean;
	isApprovedItem?: boolean;
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type GetServiceOrderApiResponse = /** status 200 OK */ ServiceOrderSerializableListResult;
export type GetServiceOrderApiArg = {
	equipmentIdCollection?: number[];
	startDate?: string;
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type PostServiceOrderApiResponse = /** status 200 OK */ ServiceOrderRead;
export type PostServiceOrderApiArg = {
	createServiceOrderRequest: CreateServiceOrderRequest;
};
export type GetServiceOrderByIdApiResponse = /** status 200 OK */ ServiceOrderRead;
export type GetServiceOrderByIdApiArg = {
	id: number;
};
export type PutServiceOrderByIdApiResponse = /** status 200 OK */ ServiceOrderRead;
export type PutServiceOrderByIdApiArg = {
	id: number;
	createServiceOrderRequest: CreateServiceOrderRequest;
};
export type GetSitesByIdSafetyApiResponse = /** status 200 OK */ StringStringStringTuple[];
export type GetSitesByIdSafetyApiArg = {
	id: number;
};
export type GetSitesDownloadApiResponse = unknown;
export type GetSitesDownloadApiArg = {
	siteCriteria: SiteCriteria;
};
export type PatchSitesUploadApiResponse = unknown;
export type PatchSitesUploadApiArg = {
	body: {
		file?: Blob;
	};
};
export type PostSitesApiResponse = /** status 200 OK */ SiteRead;
export type PostSitesApiArg = {
	site: Site;
};
export type GetSitesApiResponse = /** status 200 OK */ SiteSerializableListResultRead;
export type GetSitesApiArg = {
	searchTerm?: string;
	sortField?: string;
	sortDirection?: string;
	groupIdCollection?: number[];
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type PutSitesByIdApiResponse = /** status 200 OK */ SiteRead;
export type PutSitesByIdApiArg = {
	id: number;
	site: Site;
};
export type GetSitesByIdApiResponse = /** status 200 OK */ SiteRead;
export type GetSitesByIdApiArg = {
	id: number;
};
export type GetTemplateApiResponse = /** status 200 OK */ StockCollectionSerializableListResultRead;
export type GetTemplateApiArg = {
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type PostTemplateApiResponse = /** status 200 OK */ StockCollectionRead;
export type PostTemplateApiArg = {
	stockCollection: StockCollection;
};
export type DeleteTemplateByIdApiResponse = unknown;
export type DeleteTemplateByIdApiArg = {
	id: number;
};
export type GetTemplateByIdApiResponse = /** status 200 OK */ StockCollectionRead;
export type GetTemplateByIdApiArg = {
	id: number;
	sortBy?: string;
	categoryIdCollection?: number[];
	inStock?: boolean;
	slug?: string;
	stockcodeCollection?: string[];
	searchTerm?: string;
	isCore?: boolean;
	isApprovedItem?: boolean;
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type PutTemplateByIdApiResponse = /** status 200 OK */ StockCollectionRead;
export type PutTemplateByIdApiArg = {
	id: number;
	stockCollection: StockCollection;
};
export type PostTemplateByIdAddApiResponse = unknown;
export type PostTemplateByIdAddApiArg = {
	id: number;
	stockcode?: string;
};
export type DeleteTemplateByIdRemoveApiResponse = unknown;
export type DeleteTemplateByIdRemoveApiArg = {
	id: number;
	stockcode?: string;
};
export type GetUserApiResponse = /** status 200 OK */ UserSerializableListResult;
export type GetUserApiArg = {
	email?: string;
	hasPassword?: boolean;
	pageNumber?: number;
	pageSize?: number;
	companyIdCollection?: number[];
	userIdCollection?: number[];
	idCollection?: number[];
	includeDeleted?: boolean;
	referenceCollection?: string[];
};
export type PostUserApiResponse = /** status 200 OK */ User;
export type PostUserApiArg = {
	user: User;
};
export type GetUserByIdApiResponse = /** status 200 OK */ User;
export type GetUserByIdApiArg = {
	id: number;
};
export type PutUserByIdApiResponse = /** status 200 OK */ User;
export type PutUserByIdApiArg = {
	id: number;
	user: User;
};
export type DeleteUserByIdApiResponse = unknown;
export type DeleteUserByIdApiArg = {
	id: number;
};
export type PostUserRegisterApiResponse = unknown;
export type PostUserRegisterApiArg = {
	clerkUserCreate: ClerkUserCreate;
};
export type PostUserSetupApiResponse = unknown;
export type PostUserSetupApiArg = {
	userSetup: UserSetup;
};
export type PostUserChangePasswordApiResponse = /** status 200 OK */ boolean;
export type PostUserChangePasswordApiArg = {
	userChangePassword: UserChangePassword;
};
export type GetUserCurrentApiResponse = /** status 200 OK */ User;
export type GetUserCurrentApiArg = void;
export type GetUserNotificationByIdApiResponse = /** status 200 OK */ UserNotification;
export type GetUserNotificationByIdApiArg = {
	id: number;
};
export type PutUserNotificationByIdApiResponse = /** status 200 OK */ UserNotification;
export type PutUserNotificationByIdApiArg = {
	id: number;
	userNotification: UserNotification;
};
export type StatusType = "InStock" | "OutOfStock" | "LowStock";
export type ItemAvailability = {
	classification: string | null;
	locationId: number;
	locationName: string | null;
	status?: StatusType;
	quantity?: number;
	eta?: string | null;
	minimumQuantity?: number | null;
	vendorLeadTimeDays?: number | null;
};
export type StringStringKeyValuePair = {
	key?: string | null;
	value?: string | null;
};
export type Item = {
	stockcode: string | null;
	name: string | null;
	unitPrice?: number | null;
	tradePrice?: number | null;
	slug?: string | null;
	itemAvailability: ItemAvailability[] | null;
	imageUrl?: string | null;
	substituteCollection: string[] | null;
	relatedItemCollection?: string[] | null;
	description?: string | null;
	attributeCollection?: StringStringKeyValuePair[] | null;
	packCtnQty?: number | null;
	layerQty?: number | null;
	palletQty?: number | null;
	taxRate?: number;
	fileCollection?: string | null;
	isCore?: boolean;
	taxable?: boolean;
	financeCategory?: string | null;
	category1?: string | null;
	category2?: string | null;
	category3?: string | null;
	isGreenTag?: boolean;
	isGeca?: boolean;
	isTgaListed?: boolean;
	isFsc?: boolean;
	isPefc?: boolean;
	unspsc?: string | null;
	rechargeable?: boolean | null;
	seoTitle?: string | null;
	seoDescription?: string | null;
	isPurchaseable?: boolean;
	brand?: string | null;
	score?: number | null;
};
export type Category = {
	url?: string | null;
	name?: string | null;
	children?: Category[] | null;
};
export type ItemRead = {
	stockcode: string | null;
	name: string | null;
	unitPrice?: number | null;
	tradePrice?: number | null;
	slug?: string | null;
	itemAvailability: ItemAvailability[] | null;
	imageUrl?: string | null;
	substituteCollection: string[] | null;
	relatedItemCollection?: string[] | null;
	description?: string | null;
	attributeCollection?: StringStringKeyValuePair[] | null;
	packCtnQty?: number | null;
	layerQty?: number | null;
	palletQty?: number | null;
	taxRate?: number;
	fileCollection?: string | null;
	glCode?: string | null;
	isCore?: boolean;
	taxable?: boolean;
	financeCategory?: string | null;
	category1?: string | null;
	category2?: string | null;
	category3?: string | null;
	isGreenTag?: boolean;
	isGeca?: boolean;
	isTgaListed?: boolean;
	isFsc?: boolean;
	isPefc?: boolean;
	unspsc?: string | null;
	rechargeable?: boolean | null;
	seoTitle?: string | null;
	seoDescription?: string | null;
	categoryCollection?: Category[] | null;
	isPurchaseable?: boolean;
	imageCollection?: string[] | null;
	brand?: string | null;
	score?: number | null;
};
export type Page = {
	pageName: string | null;
	slug: string | null;
	path: string | null;
	content?: any | null;
	metaTitle?: string | null;
	metaDescription?: string | null;
	item?: Item;
	documentDate?: string | null;
	callToAction?: string | null;
	relatedItemCollection?: Item[] | null;
};
export type PageRead = {
	pageName: string | null;
	slug: string | null;
	path: string | null;
	content?: any | null;
	metaTitle?: string | null;
	metaDescription?: string | null;
	item?: ItemRead;
	documentDate?: string | null;
	callToAction?: string | null;
	featureImageUrl?: string | null;
	articleType?: number;
	relatedItemCollection?: ItemRead[] | null;
};
export type SerializableListResultMetaData = {
	totalItemCount: number;
	pageNumber: number;
	pageSize: number;
	pageCount: number;
};
export type PageSerializableListResult = {
	list: Page[] | null;
	metaData: SerializableListResultMetaData;
};
export type PageSerializableListResultRead = {
	list: PageRead[] | null;
	metaData: SerializableListResultMetaData;
};
export type ItemWithQuantity = {
	item: Item;
	quantity?: number;
};
export type ItemWithQuantityRead = {
	item: ItemRead;
	quantity?: number;
};
export type UserPermission = {
	canViewReports?: boolean;
	canViewInvoices?: boolean;
	canManageSites?: boolean;
	canViewEquipments?: boolean;
	canApplyRechargeable?: boolean;
};
export type User = {
	id?: number;
	firstName: string | null;
	lastName: string | null;
	email: string | null;
	userPermission?: UserPermission;
};
export type CartApproval = {
	dateCreated: string;
	user?: User;
	actionType: string | null;
	actionNote?: string | null;
};
export type GroupSpendResult = {
	id?: number;
	siteId?: number | null;
	companyId?: number;
	groupName?: string | null;
	totalSpend?: number | null;
	rechargeableSpend?: number | null;
	glCode?: string | null;
	glDescription?: string | null;
	parentId?: number | null;
	year?: number | null;
	month?: number | null;
	budgetAmount?: number | null;
	leafNode?: boolean | null;
};
export type Cart = {
	id?: number;
	dateCreated?: string;
	freightCharge?: number | null;
	purchaseOrderNumber?: string | null;
	totalAmount?: number | null;
	userId?: number;
	userFullName?: string | null;
	siteId?: number | null;
	siteName?: string | null;
	siteFullAddress?: string | null;
	lines?: ItemWithQuantity[] | null;
	locationId?: number;
	hasCompleted?: boolean;
	awaitingApproval?: boolean;
	approvalHistory?: CartApproval[] | null;
	potentialApprover?: User[] | null;
	pickupLocationId?: number | null;
	pickupLocationName?: string | null;
	shippingType?: string | null;
	locationType?: string | null;
	dispatchDate?: string | null;
	salesOrderId?: number | null;
	budget?: number | null;
	budgetCollection?: GroupSpendResult[] | null;
	deliveryInstructions?: string | null;
	additionalInformation?: string | null;
	tailLiftRequired?: boolean | null;
	authorityToLeave?: boolean | null;
	saveDeliveryInstructions?: boolean | null;
	hasAccountTerms?: boolean;
	paymentOption?: string | null;
	paymentTokenId?: number | null;
	isCurrentCart?: boolean;
	creditCardSurchargeCost?: number | null;
	requiresPurchaseOrderNumber?: boolean;
	requiresSite?: boolean;
};
export type CartRead = {
	id?: number;
	dateCreated?: string;
	freightCharge?: number | null;
	purchaseOrderNumber?: string | null;
	totalAmount?: number | null;
	userId?: number;
	userFullName?: string | null;
	siteId?: number | null;
	siteName?: string | null;
	siteFullAddress?: string | null;
	lines?: ItemWithQuantityRead[] | null;
	locationId?: number;
	taxAmount?: number | null;
	itemTotalAmount?: number | null;
	hasCompleted?: boolean;
	awaitingApproval?: boolean;
	approvalHistory?: CartApproval[] | null;
	potentialApprover?: User[] | null;
	pickupLocationId?: number | null;
	pickupLocationName?: string | null;
	shippingType?: string | null;
	locationType?: string | null;
	dispatchDate?: string | null;
	salesOrderId?: number | null;
	budget?: number | null;
	currentMonthSpend?: number | null;
	budgetCollection?: GroupSpendResult[] | null;
	deliveryInstructions?: string | null;
	additionalInformation?: string | null;
	tailLiftRequired?: boolean | null;
	authorityToLeave?: boolean | null;
	saveDeliveryInstructions?: boolean | null;
	hasAccountTerms?: boolean;
	paymentOption?: string | null;
	paymentTokenId?: number | null;
	isCurrentCart?: boolean;
	creditCardSurchargeCost?: number | null;
	requiresPurchaseOrderNumber?: boolean;
	siteError?: boolean;
	requiresSite?: boolean;
};
export type ItemDispatchEstimate = {
	stockcode?: string | null;
	etaString?: string | null;
};
export type CartDeliveryInfo = {
	earlierDispatchDate?: string | null;
	latestDispatchDate?: string | null;
	willTriggerBackOrder?: boolean;
	itemEstimates?: ItemDispatchEstimate[] | null;
};
export type CartCheckoutResponse = {
	id: number;
	type: string | null;
	recordType?: string | null;
};
export type CartCheckoutResponseRead = {
	id: number;
	type: string | null;
	reason?: string | null;
	recordType?: string | null;
};
export type ItemSerializableListResult = {
	list: Item[] | null;
	metaData: SerializableListResultMetaData;
};
export type ItemSerializableListResultRead = {
	list: ItemRead[] | null;
	metaData: SerializableListResultMetaData;
};
export type AddressValidationResult = {
	errorCode: string | null;
	potentialSolutions?: string[] | null;
	solutionData?: any | null;
};
export type Site = {
	suburb: string | null;
	state: string | null;
	postcode: string | null;
	addressLine1?: string | null;
	addressLine2?: string | null;
	addressLine3?: string | null;
	addressLine4?: string | null;
	addressLine5?: string | null;
	name?: string | null;
	catalogueCollection?: StockCollection[] | null;
	companyId?: number;
	id?: number;
	groupName?: string | null;
	latitude?: number | null;
	longitude?: number | null;
	reference1?: string | null;
	reference2?: string | null;
	siteContactName?: string | null;
	siteContactPhone?: string | null;
	deliveryInstructions?: string | null;
	rechargeable?: boolean;
	addressErrorCollection?: AddressValidationResult[] | null;
};
export type SiteRead = {
	suburb: string | null;
	state: string | null;
	postcode: string | null;
	addressLine1?: string | null;
	addressLine2?: string | null;
	addressLine3?: string | null;
	addressLine4?: string | null;
	addressLine5?: string | null;
	name?: string | null;
	catalogueCollection?: StockCollection[] | null;
	companyId?: number;
	id?: number;
	groupName?: string | null;
	latitude?: number | null;
	longitude?: number | null;
	reference1?: string | null;
	reference2?: string | null;
	siteContactName?: string | null;
	siteContactPhone?: string | null;
	deliveryInstructions?: string | null;
	rechargeable?: boolean;
	locationId?: number | null;
	addressErrorCollection?: AddressValidationResult[] | null;
};
export type UserGroup = {
	id?: number;
	name: string | null;
	userCollection?: User[] | null;
	canManageSites?: boolean | null;
	canViewEquipments?: boolean | null;
	canViewReports?: boolean | null;
	canViewInvoices?: boolean | null;
	enableRechargeable?: boolean | null;
	hidePrices?: boolean | null;
	canViewSiteBudget?: boolean | null;
	limitViewingToStockListItems?: boolean | null;
	limitOrderingToStocklistItems?: boolean | null;
	limitOrderingToCatalogueItems?: boolean | null;
	approvalRequiredForAllOrders?: boolean | null;
	approvalRequiredForNonStockLists?: boolean | null;
	approvalRequiredForNonCatalogueItems?: boolean | null;
	approvalRequiredForOrderOverSiteBudget?: boolean | null;
	approvalRequiredForOrderOverGroupBudget?: boolean | null;
	approvalRequiredForUrgentFastestShipping?: boolean | null;
	purchaseOrderRequiredForAllOrders?: boolean | null;
	purchaseOrderRequiredForNonStocklistItems?: boolean | null;
	purchaseOrderRequiredForNonCatalogueItems?: boolean | null;
	includeAllUsers?: boolean | null;
	allowOnlineOrdering?: boolean | null;
	canEditRechargeableItems?: boolean | null;
	disableCatalogueCreation?: boolean | null;
	canCreateRecurringOrders?: boolean | null;
	siteRequiredForAllOrders?: boolean | null;
	defaultMultipleDeliveries?: boolean | null;
};
export type Group = {
	id?: number;
	name: string | null;
	parent?: Group;
	site?: Site;
	userGroup?: UserGroup[] | null;
	catalogueCollection?: StockCollection[] | null;
	approvedStocklistCollection?: StockCollection[] | null;
	approverCollection?: User[] | null;
	purchaseOrderRegex?: string | null;
	budget?: number | null;
	monthlyBudgetCollection?: {
		[key: string]: number;
	} | null;
};
export type GroupRead = {
	id?: number;
	name: string | null;
	parent?: GroupRead;
	site?: SiteRead;
	userGroup?: UserGroup[] | null;
	catalogueCollection?: StockCollection[] | null;
	approvedStocklistCollection?: StockCollection[] | null;
	approverCollection?: User[] | null;
	purchaseOrderRegex?: string | null;
	budget?: number | null;
	monthlyBudgetCollection?: {
		[key: string]: number;
	} | null;
};
export type StockCollection = {
	id?: number;
	name: string | null;
	groupName?: string | null;
	lineCollection?: ItemSerializableListResult;
	groupCollection?: Group[] | null;
};
export type StockCollectionRead = {
	id?: number;
	name: string | null;
	groupName?: string | null;
	lineCollection?: ItemSerializableListResultRead;
	groupCollection?: GroupRead[] | null;
	lineCount?: number | null;
};
export type StockCollectionSerializableListResult = {
	list: StockCollection[] | null;
	metaData: SerializableListResultMetaData;
};
export type StockCollectionSerializableListResultRead = {
	list: StockCollectionRead[] | null;
	metaData: SerializableListResultMetaData;
};
export type ItemSubCategory = {
	name: string | null;
	slug: string | null;
	itemCollection?: Item[] | null;
	seoDescription?: string | null;
	seoTitle?: string | null;
	categoryType: string | null;
};
export type ItemSubCategoryRead = {
	name: string | null;
	slug: string | null;
	itemCollection?: ItemRead[] | null;
	seoDescription?: string | null;
	seoTitle?: string | null;
	url?: string | null;
	imageUrl?: string | null;
	categoryType: string | null;
	stockcodes?: string[] | null;
};
export type ItemCategory = {
	name: string | null;
	slug: string | null;
	categoryType: string | null;
	subCategoryCollection?: ItemSubCategory[] | null;
	imageUrl?: string | null;
	seoDescription?: string | null;
	seoTitle?: string | null;
};
export type ItemCategoryRead = {
	name: string | null;
	slug: string | null;
	categoryType: string | null;
	subCategoryCollection?: ItemSubCategoryRead[] | null;
	imageUrl?: string | null;
	url?: string | null;
	seoDescription?: string | null;
	seoTitle?: string | null;
	description?: string | null;
};
export type Company = {
	id?: number;
	name: string | null;
	companyNumber: string | null;
	paymentUrl?: string | null;
	abconetVersion?: string | null;
	disableCreditCardPayments?: boolean;
	requiresPoNumber?: boolean | null;
};
export type Location = {
	id: number;
	name: string | null;
	suburb: string | null;
	state: string | null;
	postcode: string | null;
	address1: string | null;
};
export type OrdersDashboardData = {
	deliveredInFullOnTime?: number;
	coreItems?: number;
	orders?: number;
	awaitingApproval?: number;
	backOrderedItems?: number;
};
export type OrdersDashboardPreviousData = {
	orders?: number;
};
export type OrdersDashboard = {
	currentYear?: OrdersDashboardData;
	previousYear?: OrdersDashboardPreviousData;
};
export type SpendDashboardData = {
	month?: string | null;
	year?: number;
	spend?: number;
	budget?: number;
	orders?: number;
};
export type SpendDashboardPreviousData = {
	orders?: number;
	sites?: number;
};
export type SpendDashboard = {
	currentYear?: SpendDashboardData[] | null;
	previousYear?: SpendDashboardPreviousData;
};
export type ProductsDashboard = {
	uniqueItemsOrdered?: number;
	catalogueSpecialItems?: number;
	catalogueSpecialItemsForReplacement?: number;
	catalogueDiscontinuedItems?: number;
	stocklistDiscontinuedItems?: number;
};
export type ProductsDashboardRead = {
	uniqueItemsOrdered?: number;
	enviroplusItemsOrdered?: number;
	catalogueSpecialItems?: number;
	catalogueSpecialItemsForReplacement?: number;
	catalogueDiscontinuedItems?: number;
	stocklistDiscontinuedItems?: number;
};
export type EquipmentDashboard = {
	servicedByAbco?: number;
	dueForService?: number;
	totalMachineHours?: number;
	hireDueForReturn?: number;
	outstandingEmergencyRepairs?: number;
};
export type SitesDashboard = {
	withActivity?: number;
	overBudget?: number;
	overBudgetGroups?: number;
	withoutActivity?: number;
	withoutBudget?: number;
	withoutGroup?: number;
};
export type SustainabilityDashboardData = {
	totalOrders?: number;
	totalOrderLines?: number;
	totalEnviroplusLines?: number;
	enviroplusPercentage?: number;
};
export type SustainabilityDashboardDataRead = {
	totalOrders?: number;
	totalOrderLines?: number;
	totalEnviroplusLines?: number;
	enviroplusPercentage?: number;
	carbonOffsetTons?: number;
	litresOfCleanDrinkingWater?: number;
	booksDonated?: number;
	recycledContentKg?: number;
	sugarcaneBagasseKg?: number;
};
export type SustainabilityDashboard = {
	currentYear?: SustainabilityDashboardData;
	previousYear?: SustainabilityDashboardData;
};
export type SustainabilityDashboardRead = {
	currentYear?: SustainabilityDashboardDataRead;
	previousYear?: SustainabilityDashboardDataRead;
};
export type TechnicianTrip = {
	id: number;
	title?: string | null;
	details?: string | null;
	technician?: string | null;
	startDate?: string | null;
	endDate?: string | null;
	type?: string | null;
	status?: string | null;
};
export type ServiceOrder = {
	id: number;
	caseNumber?: string | null;
	serviceType?: string | null;
	problemDescription?: string | null;
	workflowStatus?: string | null;
	startDate?: string | null;
	dueDate?: string | null;
	technicianTripCollection?: TechnicianTrip[] | null;
	equipmentCollection?: Equipment[] | null;
	userId?: number;
	siteId?: number | null;
};
export type ServiceOrderRead = {
	id: number;
	caseNumber?: string | null;
	serviceType?: string | null;
	problemDescription?: string | null;
	workflowStatus?: string | null;
	startDate?: string | null;
	dueDate?: string | null;
	technicianTripCollection?: TechnicianTrip[] | null;
	equipmentCollection?: Equipment[] | null;
	userId?: number;
	siteId?: number | null;
};
export type Equipment = {
	id?: number;
	serialNumber: string | null;
	make?: string | null;
	model?: string | null;
	installationDate?: string | null;
	lastServiceDate?: string | null;
	nextServiceDueDate?: string | null;
	soldDate?: string | null;
	fileCollection?: string | null;
	trainingVideo?: string | null;
	type?: string | null;
	warrantyPeriod?: string | null;
	siteName?: string | null;
	latitude?: number | null;
	longitude?: number | null;
	serviceOrderCollection?: ServiceOrder[] | null;
	isHire?: boolean;
	hireStartDate?: string | null;
	hireEndDate?: string | null;
	hireStatus?: string | null;
	stockcode?: string | null;
	warrantyEndDate?: string | null;
	slug?: string | null;
};
export type EquipmentRead = {
	id?: number;
	serialNumber: string | null;
	make?: string | null;
	model?: string | null;
	installationDate?: string | null;
	lastServiceDate?: string | null;
	nextServiceDueDate?: string | null;
	soldDate?: string | null;
	fileCollection?: string | null;
	trainingVideo?: string | null;
	type?: string | null;
	warrantyPeriod?: string | null;
	siteName?: string | null;
	latitude?: number | null;
	longitude?: number | null;
	serviceOrderCollection?: ServiceOrderRead[] | null;
	isHire?: boolean;
	hireStartDate?: string | null;
	hireEndDate?: string | null;
	hireStatus?: string | null;
	stockcode?: string | null;
	imageUrl?: string | null;
	warrantyEndDate?: string | null;
	slug?: string | null;
};
export type EquipmentSerializableListResult = {
	list: Equipment[] | null;
	metaData: SerializableListResultMetaData;
};
export type EquipmentSerializableListResultRead = {
	list: EquipmentRead[] | null;
	metaData: SerializableListResultMetaData;
};
export type EquipmentType = {
	id?: number;
	description?: string | null;
};
export type AssetLoggingEvent = {
	latitude?: number | null;
	longitude?: number | null;
};
export type GlAccount = {
	id?: number;
	name: string | null;
	code: string | null;
	lineCollection?: ItemSerializableListResult;
};
export type GlAccountRead = {
	id?: number;
	name: string | null;
	code: string | null;
	lineCollection?: ItemSerializableListResultRead;
};
export type GlAccountSerializableListResult = {
	list: GlAccount[] | null;
	metaData: SerializableListResultMetaData;
};
export type GlAccountSerializableListResultRead = {
	list: GlAccountRead[] | null;
	metaData: SerializableListResultMetaData;
};
export type TreeNode = {
	id?: number;
	name: string | null;
	type: string | null;
	siteId?: number | null;
	children?: TreeNode[] | null;
	userGroup?: UserGroup[] | null;
};
export type GroupRole = {
	id?: number;
	description: string | null;
};
export type GroupRoleSerializableListResult = {
	list: GroupRole[] | null;
	metaData: SerializableListResultMetaData;
};
export type InvoiceLine = {
	id?: number;
	stockcode: string | null;
	description?: string | null;
	quantity?: number;
	unitPrice?: number | null;
	total?: number;
	backOrderQuantity?: number | null;
	parent?: Invoice;
	rechargeable?: boolean;
	taxTotal?: number;
	item?: Item;
};
export type InvoiceLineRead = {
	id?: number;
	stockcode: string | null;
	description?: string | null;
	quantity?: number;
	unitPrice?: number | null;
	total?: number;
	backOrderQuantity?: number | null;
	parent?: Invoice;
	rechargeable?: boolean;
	taxTotal?: number;
	item?: ItemRead;
};
export type OrderLine = {
	stockcode: string | null;
	quantity?: number;
	referenceId: string | null;
	total?: number;
	backOrderQuantity?: number | null;
	suppliedQuantity?: number | null;
	parent?: Order;
	description?: string | null;
	unitPrice?: number | null;
	taxTotal?: number;
	item?: Item;
};
export type OrderLineRead = {
	stockcode: string | null;
	quantity?: number;
	referenceId: string | null;
	total?: number;
	backOrderQuantity?: number | null;
	suppliedQuantity?: number | null;
	parent?: Order;
	description?: string | null;
	unitPrice?: number | null;
	taxTotal?: number;
	item?: ItemRead;
};
export type Pod = {
	imageUrl?: string | null;
	fileType?: string | null;
};
export type Order = {
	id?: number;
	total?: number;
	subTotal?: number;
	taxTotal?: number;
	documentNumber: string | null;
	siteName?: string | null;
	orderedBy?: string | null;
	transactionDateUtc?: string;
	lineCollection: OrderLine[] | null;
	site?: Site;
	poNumber?: string | null;
	user?: User;
	locationId?: number | null;
	cartId?: number | null;
	podCollection?: Pod[] | null;
	freightCharge?: number | null;
	status?: string | null;
};
export type OrderRead = {
	id?: number;
	total?: number;
	subTotal?: number;
	taxTotal?: number;
	documentNumber: string | null;
	siteName?: string | null;
	orderedBy?: string | null;
	transactionDateUtc?: string;
	siteId?: number | null;
	lineCollection: OrderLineRead[] | null;
	site?: SiteRead;
	poNumber?: string | null;
	user?: User;
	locationId?: number | null;
	cartId?: number | null;
	podCollection?: Pod[] | null;
	freightCharge?: number | null;
	status?: string | null;
};
export type Invoice = {
	id?: number;
	referenceId: string | null;
	documentNumber: string | null;
	transactionDateUtc: string;
	lineCollection?: InvoiceLine[] | null;
	total?: number;
	subTotal?: number;
	taxTotal?: number;
	siteId?: number | null;
	site?: Site;
	salesOrderId?: number | null;
	order?: Order;
	poNumber?: string | null;
	company?: Company;
};
export type InvoiceRead = {
	id?: number;
	referenceId: string | null;
	documentNumber: string | null;
	transactionDateUtc: string;
	lineCollection?: InvoiceLineRead[] | null;
	total?: number;
	subTotal?: number;
	taxTotal?: number;
	siteId?: number | null;
	site?: SiteRead;
	salesOrderId?: number | null;
	order?: OrderRead;
	poNumber?: string | null;
	company?: Company;
};
export type InvoiceSerializableListResult = {
	list: Invoice[] | null;
	metaData: SerializableListResultMetaData;
};
export type InvoiceSerializableListResultRead = {
	list: InvoiceRead[] | null;
	metaData: SerializableListResultMetaData;
};
export type ItemCriteria = {
	pageNumber?: number | null;
	pageSize?: number | null;
	companyIdCollection?: number[] | null;
	userIdCollection?: number[] | null;
	idCollection?: number[] | null;
	referenceCollection?: string[] | null;
	sortBy?: string | null;
	categoryIdCollection?: number[] | null;
	inStock?: boolean | null;
	slug?: string | null;
	stockcodeCollection?: string[] | null;
	searchTerm?: string | null;
	isCore?: boolean | null;
	isApprovedItem?: boolean | null;
};
export type Notification = {
	id?: number;
	eventType: string | null;
	transactionNumber?: string | null;
	transactionId?: number | null;
	dateCreated?: string;
	hasRead?: boolean;
};
export type NotificationRead = {
	id?: number;
	eventType: string | null;
	transactionNumber?: string | null;
	transactionId?: number | null;
	dateCreated?: string;
	hasRead?: boolean;
	siteName?: string | null;
};
export type NotificationSerializableListResult = {
	list: Notification[] | null;
	metaData: SerializableListResultMetaData;
};
export type NotificationSerializableListResultRead = {
	list: NotificationRead[] | null;
	metaData: SerializableListResultMetaData;
};
export type OrderCart = {
	dateUtc?: string;
	id?: number;
	documentNumber: string | null;
	type: string | null;
	siteId?: number | null;
	siteName?: string | null;
	status?: string | null;
	total?: number;
};
export type OrderCartRead = {
	dateUtc?: string;
	id?: number;
	documentNumber: string | null;
	type: string | null;
	siteId?: number | null;
	siteName?: string | null;
	orderedBy?: string | null;
	orderedById?: number | null;
	status?: string | null;
	total?: number;
};
export type OrderCartSerializableListResult = {
	list: OrderCart[] | null;
	metaData: SerializableListResultMetaData;
};
export type OrderCartSerializableListResultRead = {
	list: OrderCartRead[] | null;
	metaData: SerializableListResultMetaData;
};
export type PaymentToken = {
	paymentId?: number;
	paymentMask: string | null;
};
export type CreditCard = {
	number: string | null;
	name: string | null;
	month: string | null;
	year: string | null;
	cvv: string | null;
};
export type ScheduleReport = {
	id?: number;
	expression?: string | null;
	userId?: number;
	companyId?: number;
	reportId?: number;
	reportName?: string | null;
	nextOccurenceDate?: string;
	period?: string | null;
	cronDescription?: string | null;
	timezone?: string | null;
};
export type ScheduleReportSerializableListResult = {
	list: ScheduleReport[] | null;
	metaData: SerializableListResultMetaData;
};
export type SiteSerializableListResult = {
	list: Site[] | null;
	metaData: SerializableListResultMetaData;
};
export type SiteSerializableListResultRead = {
	list: SiteRead[] | null;
	metaData: SerializableListResultMetaData;
};
export type SearchResult = {
	itemCollection?: ItemSerializableListResult;
	siteCollection?: SiteSerializableListResult;
};
export type SearchResultRead = {
	itemCollection?: ItemSerializableListResultRead;
	siteCollection?: SiteSerializableListResultRead;
};
export type ServiceOrderSerializableListResult = {
	list: ServiceOrder[] | null;
	metaData: SerializableListResultMetaData;
};
export type CreateServiceOrderRequest = {
	problemDescription: string | null;
	equipmentCollection?: number[] | null;
	siteId?: number;
	serviceType?: string | null;
};
export type StringStringStringTuple = {
	item1?: string | null;
	item2?: string | null;
	item3?: string | null;
};
export type SiteCriteria = {
	pageNumber?: number | null;
	pageSize?: number | null;
	companyIdCollection?: number[] | null;
	userIdCollection?: number[] | null;
	idCollection?: number[] | null;
	referenceCollection?: string[] | null;
	searchTerm?: string | null;
	sortField?: string | null;
	sortDirection?: string | null;
	groupIdCollection?: number[] | null;
};
export type UserSerializableListResult = {
	list: User[] | null;
	metaData: SerializableListResultMetaData;
};
export type Verification = {
	status?: string | null;
	strategy?: string | null;
};
export type EmailAddressData = {
	emailAddress?: string | null;
	id?: string | null;
	linkedTo?: any[] | null;
	object?: string | null;
	verification?: Verification;
};
export type PrivateMetadata = object;
export type CompanyInformation = {
	name?: string | null;
	subsidiaryCollection?: number[] | null;
};
export type PublicMetadata = {
	companyData?: {
		[key: string]: CompanyInformation;
	} | null;
	isSuperAdmin?: boolean;
};
export type UnsafeMetadata = {
	companyId?: number | null;
};
export type Data = {
	birthday?: string | null;
	createdAt?: number | null;
	emailAddresses?: EmailAddressData[] | null;
	externalAccounts?: any[] | null;
	externalId?: string | null;
	firstName?: string | null;
	gender?: string | null;
	id?: string | null;
	imageUrl?: string | null;
	lastName?: string | null;
	lastSignInAt?: number | null;
	object?: string | null;
	passwordEnabled?: boolean | null;
	phoneNumbers?: any[] | null;
	primaryEmailAddressId?: string | null;
	primaryPhoneNumberId?: any | null;
	primaryWeb3WalletId?: any | null;
	privateMetadata?: PrivateMetadata;
	profileImageUrl?: string | null;
	publicMetadata?: PublicMetadata;
	twoFactorEnabled?: boolean | null;
	unsafeMetadata?: UnsafeMetadata;
	updatedAt?: number | null;
	username?: any | null;
	web3Wallets?: any[] | null;
};
export type HttpRequest = {
	clientIp?: string | null;
	userAgent?: string | null;
};
export type EventAttributes = {
	httpRequest?: HttpRequest;
};
export type ClerkUserCreate = {
	data?: Data;
	eventAttributes?: EventAttributes;
	object?: string | null;
	timestamp?: number | null;
	type?: string | null;
};
export type UserSetup = {
	companyName?: string | null;
};
export type UserChangePassword = {
	oldPassword: string | null;
	newPassword: string | null;
};
export type NotificationType = {
	push?: boolean;
	email?: boolean;
	text?: boolean;
};
export type UserNotification = {
	id?: number;
	companyId?: number;
	cartAwaitingForApprovalNotification?: NotificationType;
	cartApprovedNotification?: NotificationType;
	cartRejectedNotification?: NotificationType;
	shippingInProgressNotification?: NotificationType;
	shippingInTransitNotification?: NotificationType;
	shippingCompletedNotification?: NotificationType;
	shippingFailureNotification?: NotificationType;
	orderConfirmationNotification?: NotificationType;
	invoiceCreatedNotification?: NotificationType;
};
export const {
	useGetArticleQuery,
	useGetCartCurrentQuery,
	useGetCartCurrentdeliveryinfoQuery,
	usePutCartCurrentItemMutation,
	usePostCartMutation,
	usePutCartByIdMutation,
	useGetCartByIdQuery,
	usePostCartByIdCheckoutMutation,
	usePostCartByIdSetcurrentcartMutation,
	usePostCartByIdRejectMutation,
	usePostCartByIdClearMutation,
	usePostCatalogueMutation,
	useGetCatalogueQuery,
	useDeleteCatalogueByIdMutation,
	useGetCatalogueByIdQuery,
	usePutCatalogueByIdMutation,
	usePostCatalogueByIdAddMutation,
	useDeleteCatalogueByIdRemoveMutation,
	usePutCatalogueByIdUpdateMutation,
	useGetCategoryQuery,
	useGetCategoryBySlugQuery,
	useGetCategoryByCategorySlugAndSubCategorySlugQuery,
	useGetCompanyQuery,
	useGetCompanyLocationsQuery,
	useGetDashboardOrdersQuery,
	useGetDashboardSpendQuery,
	useGetDashboardProductsQuery,
	useGetDashboardEquipmentsQuery,
	useGetDashboardSitesQuery,
	useGetDashboardSustainabilityQuery,
	useGetEquipmentQuery,
	useGetEquipmentByIdQuery,
	useGetEquipmentRedirectByIdQuery,
	useGetEquipmentEquipmenttypeQuery,
	usePostEquipmentByIdLogMutation,
	useGetGlAccountQuery,
	usePostGlAccountMutation,
	useGetGlAccountByIdQuery,
	usePutGlAccountByIdMutation,
	useDeleteGlAccountByIdMutation,
	usePostGlAccountByIdAddstockcodeMutation,
	useDeleteGlAccountByIdDeletestockcodeMutation,
	useGetGroupQuery,
	usePostGroupMutation,
	useGetGroupByIdQuery,
	usePutGroupByIdMutation,
	useDeleteGroupByIdMutation,
	usePostGroupByIdCreategroupMutation,
	usePostGroupByIdCreatesiteMutation,
	usePutGroupByIdMoveMutation,
	useGetGroupRoleQuery,
	usePostGroupRoleMutation,
	useGetGroupRoleByIdQuery,
	usePutGroupRoleByIdMutation,
	useDeleteGroupRoleByIdMutation,
	useGetInvoiceQuery,
	useGetInvoiceByDocumentNumberQuery,
	useGetItemQuery,
	usePostItemFindMutation,
	useGetItemBySlugQuery,
	useGetRecommendedQuery,
	useGetNotificationQuery,
	usePostNotificationMarkreadMutation,
	usePostNotificationMarkunreadMutation,
	useGetOrderQuery,
	useGetOrderByDocumentNumberQuery,
	usePostOrderByDocumentNumberReorderMutation,
	useGetPageQuery,
	usePostPageSyncMutation,
	useGetPageSitemapQuery,
	useGetPageProductfeedQuery,
	useGetPageGeneratemetaQuery,
	useGetPaymentQuery,
	usePostPaymentMutation,
	useDeletePaymentMutation,
	usePostRechargeableitemsMutation,
	usePostBackordersMutation,
	usePostStockusagebysiteMutation,
	usePostStockusagebysitebymonthMutation,
	usePostPurchasesMutation,
	usePostOperationsMutation,
	usePostDifotMutation,
	useGetScheduleEventQuery,
	usePostScheduleEventMutation,
	useGetScheduleEventByIdQuery,
	usePutScheduleEventByIdMutation,
	useDeleteScheduleEventByIdMutation,
	useGetSearchQuery,
	useGetServiceOrderQuery,
	usePostServiceOrderMutation,
	useGetServiceOrderByIdQuery,
	usePutServiceOrderByIdMutation,
	useGetSitesByIdSafetyQuery,
	useGetSitesDownloadQuery,
	usePatchSitesUploadMutation,
	usePostSitesMutation,
	useGetSitesQuery,
	usePutSitesByIdMutation,
	useGetSitesByIdQuery,
	useGetTemplateQuery,
	usePostTemplateMutation,
	useDeleteTemplateByIdMutation,
	useGetTemplateByIdQuery,
	usePutTemplateByIdMutation,
	usePostTemplateByIdAddMutation,
	useDeleteTemplateByIdRemoveMutation,
	useGetUserQuery,
	usePostUserMutation,
	useGetUserByIdQuery,
	usePutUserByIdMutation,
	useDeleteUserByIdMutation,
	usePostUserRegisterMutation,
	usePostUserSetupMutation,
	usePostUserChangePasswordMutation,
	useGetUserCurrentQuery,
	useGetUserNotificationByIdQuery,
	usePutUserNotificationByIdMutation,
} = injectedRtkApi;
